import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["color"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9.16536 1.66602L0.832031 9.99935L9.16536 18.3327",
  stroke: "white",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    width: "10",
    height: "20",
    viewBox: "0 0 10 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    color: _ctx.fill ? 'fill: ' + _ctx.fill : ''
  }, _hoisted_3, 8, _hoisted_1))
}